import RelatedMediaCard from "./RelatedMediaCard";
import { toSafePathSegment } from "~/utils";

interface RelatedMediaItem {
  id: number;
  name: string;
  slug?: string;
  subtitle?: string;
  description: string;
  firstPicture: {
    id: string;
    name: string;
    file: {
      url: string;
      thumb: {
        url: string;
      };
      small: {
        url: string;
      };
      slider?: {
        url: string;
      };
    };
  };
  mediaKindsAsString: string;
  secondaryEducationAsString: string;
  extent?: {
    id: number;
    name: string;
  };
}

interface RelatedMediaListProps {
  relatedMedia: RelatedMediaItem[];
  linkPattern?: string;
  maxItems?: number;
}

export default function RelatedMediaList({
  relatedMedia,
  linkPattern = "search/main",
  maxItems = 15,
}: RelatedMediaListProps) {
  if (!relatedMedia || relatedMedia.length === 0) {
    return (
      <p className="text-sm text-slate-400">Keine passenden Medien gefunden</p>
    );
  }

  const displayedMedia = relatedMedia.slice(0, maxItems);

  return (
    <div className="mt-2 space-y-0 overflow-y-auto">
      {displayedMedia.map((media) => {
        const slugifiedName = toSafePathSegment(media.slug || media.name);
        return (
          <RelatedMediaCard
            key={media.id}
            {...media}
            linkTo={`/${linkPattern}/${media.id}/${slugifiedName}`}
          />
        );
      })}
    </div>
  );
}
